import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
@Component({
  selector: 'app-frequently',
  standalone: true,
  imports: [CommonModule, AccordionModule],
  templateUrl: './frequently.component.html',
  styleUrl: './frequently.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class FrequentlyComponent {
  frequentlyQuestions = {
    background: '/images/questions/1.png', // Background image
    title: 'frequently Questions',
    description:
      'Stay connected with reliable internet from Cladded Glass Broadband.',
    faqs: [
      {
        question: '1. What areas do you serve?',
        answer:
          'Currently we serve the Purcellville South area, from Rt 50 to Silcott Springs. We also cover Snickersville area of Philomont, north to Hamilton and Purcellville town limits.'
      },
      {
        question: '2. Are you going to provide service in other areas?',
        answer:
          'We are always expanding our network organically and growing from the edges.'
      },
      {
        question: '3. What services do you offer?',
        answer:
          'Our network is full fiber to the home and we also offer telephone service. Due to how our network is designed, we are able to offer our customers a 100% custom service, at any speed.'
      },
      {
        question: '4. What is your service reliability like?',
        answer:
          'We pride ourself in an EXTREMELY reliable service and have a 99.999% uptime over 4 years.'
      },
      {
        question: '5. Are you going to dig up my yard?',
        answer:
          'We take pride in our work. We use a variety of least invasive methods to get our fiber in the ground. Unfortunately, this is Western Loudoun and rock does exist. On rare occasion we have to dig, but it is by far a rare occurence.',
      }
    ],
  };
}
